import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_2 = {
  class: "modal fade",
  id: "detailviewModal",
  tabindex: "-1",
  "aria-labelledby": "detailviewModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = {
  class: "modal-title",
  id: "renameModalLabel"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "image-wrap my-4" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"row\"><div class=\"col-md-4\"><button class=\"btn default-btn outline\">Previous</button></div><div class=\"col-md-4 text-center\"><button class=\"btn default-btn\"><i class=\"fa fa-download mr-1\"></i> Download </button></div><div class=\"col-md-4 text-right\"><button class=\"btn default-btn outline\">Next</button></div></div>", 1)
const _hoisted_11 = { class: "modal-footer" }
const _hoisted_12 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn default-btn"
}, "Copy", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("h5", _hoisted_6, _toDisplayString(_ctx.selected.filename), 1),
            _createVNode("button", {
              type: "button",
              class: "close",
              "data-dismiss": "modal",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDetailModal && _ctx.closeDetailModal(...args))),
              "aria-label": "Close"
            }, [
              _hoisted_7
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("img", {
                class: "w-100",
                src: _ctx.selected.filepath,
                alt: ""
              }, null, 8, ["src"])
            ]),
            _hoisted_10
          ]),
          _createVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode("button", {
              type: "button",
              class: "btn secondary-btn",
              "data-dismiss": "modal",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeDetailModal && _ctx.closeDetailModal(...args)))
            }, " Close ")
          ])
        ])
      ])
    ])
  ]))
}